// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict, List } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    publicGetApiV1ExchangeInfo (params?: {}): Promise<Dict>;
    publicGetQuoteV1Depth (params?: {}): Promise<Dict>;
    publicGetQuoteV1Trades (params?: {}): Promise<List>;
    publicGetQuoteV1Klines (params?: {}): Promise<List>;
    publicGetQuoteV1Ticker24hr (params?: {}): Promise<List>;
    publicGetQuoteV1TickerPrice (params?: {}): Promise<List>;
    publicGetQuoteV1TickerBookTicker (params?: {}): Promise<List>;
    publicGetQuoteV1DepthMerged (params?: {}): Promise<Dict>;
    publicGetQuoteV1MarkPrice (params?: {}): Promise<Dict>;
    publicGetQuoteV1Index (params?: {}): Promise<Dict>;
    publicGetApiV1FuturesFundingRate (params?: {}): Promise<List>;
    publicGetApiV1FuturesHistoryFundingRate (params?: {}): Promise<List>;
    publicGetApiV1Ping (params?: {}): Promise<Dict>;
    publicGetApiV1Time (params?: {}): Promise<Dict>;
    privateGetApiV1SpotOrder (params?: {}): Promise<Dict>;
    privateGetApiV1SpotOpenOrders (params?: {}): Promise<List>;
    privateGetApiV1SpotTradeOrders (params?: {}): Promise<List>;
    privateGetApiV1FuturesLeverage (params?: {}): Promise<List>;
    privateGetApiV1FuturesOrder (params?: {}): Promise<Dict>;
    privateGetApiV1FuturesOpenOrders (params?: {}): Promise<List>;
    privateGetApiV1FuturesUserTrades (params?: {}): Promise<List>;
    privateGetApiV1FuturesPositions (params?: {}): Promise<List>;
    privateGetApiV1FuturesHistoryOrders (params?: {}): Promise<List>;
    privateGetApiV1FuturesBalance (params?: {}): Promise<List>;
    privateGetApiV1FuturesLiquidationAssignStatus (params?: {}): Promise<List>;
    privateGetApiV1FuturesRiskLimit (params?: {}): Promise<List>;
    privateGetApiV1FuturesCommissionRate (params?: {}): Promise<Dict>;
    privateGetApiV1FuturesGetBestOrder (params?: {}): Promise<Dict>;
    privateGetApiV1CoinInfo (params?: {}): Promise<Dict>;
    privateGetApiV1AccountVipInfo (params?: {}): Promise<Dict>;
    privateGetApiV1Account (params?: {}): Promise<Dict>;
    privateGetApiV1AccountTrades (params?: {}): Promise<List>;
    privateGetApiV1AccountType (params?: {}): Promise<List>;
    privateGetApiV1AccountChainType (params?: {}): Promise<List>;
    privateGetApiV1AccountCheckApiKey (params?: {}): Promise<Dict>;
    privateGetApiV1AccountBalanceFlow (params?: {}): Promise<List>;
    privateGetApiV1SpotSubAccountOpenOrders (params?: {}): Promise<List>;
    privateGetApiV1SpotSubAccountTradeOrders (params?: {}): Promise<List>;
    privateGetApiV1SubAccountTrades (params?: {}): Promise<List>;
    privateGetApiV1FuturesSubAccountOpenOrders (params?: {}): Promise<List>;
    privateGetApiV1FuturesSubAccountHistoryOrders (params?: {}): Promise<List>;
    privateGetApiV1FuturesSubAccountUserTrades (params?: {}): Promise<List>;
    privateGetApiV1AccountDepositAddress (params?: {}): Promise<Dict>;
    privateGetApiV1AccountDepositOrders (params?: {}): Promise<List>;
    privateGetApiV1AccountWithdrawOrders (params?: {}): Promise<List>;
    privateGetApiV1AffiliateInviteeInfo (params?: {}): Promise<List>;
    privatePostApiV1UserDataStream (params?: {}): Promise<Dict>;
    privatePostApiV1SpotOrderTest (params?: {}): Promise<Dict>;
    privatePostApiV1SpotOrder (params?: {}): Promise<Dict>;
    privatePostApiV11SpotOrder (params?: {}): Promise<Dict>;
    privatePostApiV1SpotBatchOrders (params?: {}): Promise<Dict>;
    privatePostApiV1FuturesLeverage (params?: {}): Promise<Dict>;
    privatePostApiV1FuturesOrder (params?: {}): Promise<Dict>;
    privatePostApiV1FuturesMarginType (params?: {}): Promise<Dict>;
    privatePostApiV1FuturesPositionMargin (params?: {}): Promise<Dict>;
    privatePostApiV1FuturesPositionTradingStop (params?: {}): Promise<Dict>;
    privatePostApiV1FuturesBatchOrders (params?: {}): Promise<Dict>;
    privatePostApiV1AccountAssetTransfer (params?: {}): Promise<Dict>;
    privatePostApiV1AccountAuthAddress (params?: {}): Promise<Dict>;
    privatePostApiV1AccountWithdraw (params?: {}): Promise<Dict>;
    privatePutApiV1UserDataStream (params?: {}): Promise<Dict>;
    privateDeleteApiV1SpotOrder (params?: {}): Promise<Dict>;
    privateDeleteApiV1SpotOpenOrders (params?: {}): Promise<List>;
    privateDeleteApiV1SpotCancelOrderByIds (params?: {}): Promise<Dict>;
    privateDeleteApiV1SpotCancelAllOpenOrders (params?: {}): Promise<Dict>;
    privateDeleteApiV1FuturesOrder (params?: {}): Promise<Dict>;
    privateDeleteApiV1FuturesBatchOrders (params?: {}): Promise<Dict>;
    privateDeleteApiV1FuturesCancelOrderByIds (params?: {}): Promise<Dict>;
    privateDeleteApiV1FuturesCancelAllOpenOrders (params?: {}): Promise<Dict>;
    privateDeleteApiV1UserDataStream (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
